import { render, staticRenderFns } from "./FAQDetails.vue?vue&type=template&id=c49ddb30&scoped=true&"
import script from "./FAQDetails.vue?vue&type=script&lang=js&"
export * from "./FAQDetails.vue?vue&type=script&lang=js&"
import style0 from "./FAQDetails.vue?vue&type=style&index=0&id=c49ddb30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49ddb30",
  null
  
)

export default component.exports